import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import Tooltip from '@mui/material/Tooltip';
import { Offer } from "./OffersContainer";
import { useAppDispatch } from "../../../../../state/state";
import { openModal } from "../../../../../state/ModalSlice/ModalSlice";
import { setFieldsForEditOfferModal } from "../../../../../state/ArbitrarySlice/ArbitratySlice";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { useNavigate } from 'react-router-dom';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';

export default function OffersListRenderer({ offer }: { offer: Offer }) {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    function onClickEditOffer(e: React.MouseEvent<HTMLDivElement>) {
        e.stopPropagation();
        dispatch(setFieldsForEditOfferModal({ offerId: offer.id }))
        dispatch(openModal("EditOfferModalOpen"))
    }


    return (
        <div className="w-full" onClick={() => {
            navigate(`/offerdetail/${offer.id}`)
        }}>
            <div className="flex cursor-pointer mt-2 shadow-md border-[1px] border-gray-300  hover:bg-gray-100  bg-white rounded-xl p-2  h-[7.5rem] w-full">
                <div className="rounded-lg overflow-hidden ">
                    <img className="h-[100%] aspect-square" src={offer.url} />
                </div>
                <div className="ml-4 w-[87%] relative">
                    <div className="flex items-center justify-between w-full">
                        <p className="text-cc_brand font-semibold">{offer.BuzzName}</p>
                        <p className={`text-xs ${offer.isLive ? "bg-cc_success" : "bg-cc_bg-paused"} rounded-lg px-2 py-1 text-white font-semibold`}>{offer.isLive ? "LIVE" : "EXPIRED"}</p>
                    </div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <div className="flex items-center gap-1">
                            <CalendarTodayIcon fontSize="small" style={{ color: '#808080' }} />
                            <p className="text-sm">valid until {new Date(offer.EndDate.seconds * 1000).toLocaleDateString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            })}</p>
                        </div>
                        <div className="flex items-center gap-2">
                            <p className="text-sm font-semibold"><span className="font-normal">Code:</span> {offer.OfferCode}</p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <div className="flex items-center gap-1">
                            <LocationOnOutlinedIcon fontSize="small" style={{ color: '#808080' }} />
                            <p className="text-sm">Venue : {offer.geoLocation.placeName}</p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between w-full pt-1.5">
                        <div className="flex items-center gap-4 w-full">
                            <Tooltip title="Participants" placement="top">
                                <span className="text-sm">
                                    <PeopleOutlineIcon fontSize="small" style={{ color: '#808080' }} /> {offer.participants||0}
                                </span>
                            </Tooltip>
                            <p className="text-sm font-semibold">{offer.Price === 0 ? 'FREE' : `Price: ₹${offer.Price}`}</p>
                        </div>
                    </div>
                    <Tooltip title="Edit Offer" placement="top">
                        <div onClick={onClickEditOffer} className="absolute bottom-0 right-0 hover:bg-gray-300 rounded-full px-2 p-1.5">
                            <EditRoundedIcon
                                className="rounded-full"
                                fontSize="small"
                                style={{ color: '#808080' }}
                            />
                        </div>
                    </Tooltip>
                </div>
            </div>
        </div>
    )
}